import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function ContactPage() {
  return <div className="pt-20 min-h-screen bg-gray-50" data-id="element-425" data-mp="nxg9fb46jqzz">
      <div className="bg-navy-900 text-white py-16" data-id="element-426" data-mp="spzo6belss6d">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-427" data-mp="sscbl434ruqt">
          <div className="text-gold-500 font-semibold tracking-[0.24em] uppercase text-xs mb-5" data-id="element-428" data-mp="xoucfsvcb8xv">
            Confidential inquiries
          </div>
          <h1 className="text-4xl font-serif font-bold mb-4" data-id="element-429" data-mp="50f0jf7i96qr">Discuss a leadership mandate.</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-430" data-mp="a01g3vat2z2q">For executive search, advisory, or career-positioning inquiries, contact our team through a verified TalentBridge channel.</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-8 pb-20" data-id="element-431" data-mp="1lfq32mo27y3j">
        <div className="bg-white rounded-xl shadow-xl overflow-hidden grid grid-cols-1 lg:grid-cols-2" data-id="element-432" data-mp="1qe1bqu2mc2k6">
          {/* Form */}
          <div className="p-8 md:p-12" data-id="element-433" data-mp="r0yeesdnyad0">
            <h2 className="text-2xl font-bold text-navy-900 mb-3" data-id="element-434" data-mp="qzvkscoyhtte">
              Send us a message
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6" data-id="element-435" data-mp="mx8skaodi6vo">
              We review inquiries through our official channels and treat search-related conversations with discretion. Please do not send payment information, banking credentials, or government identification through this form.
            </p>
            <iframe title="Contact form" src="https://form.jotform.com/261658116470559" className="w-full min-h-[600px] border-0" scrolling="no" data-id="element-436" data-mp="3b43igcwmvve" />
          </div>

          {/* Info */}
          <div className="bg-navy-50 p-8 md:p-12 flex flex-col justify-between" data-id="element-437" data-mp="3qh3gepqcfe6i">
            <div data-id="element-438" data-mp="3lfnr2lh4ulib">
              <h2 className="text-2xl font-bold text-navy-900 mb-6" data-id="element-439" data-mp="3lg7bq9y63o01">
                Contact Information
              </h2>
              <ul className="space-y-6" data-id="element-440" data-mp="3gjp7rcanvtor">
                <li className="flex items-start space-x-4" data-id="element-441" data-mp="36tqr25jlmq7h">
                  <MapPin className="h-6 w-6 text-gold-500 mt-1" data-id="element-442" data-mp="36wcym56hp5pp" />
                  <div data-id="element-443" data-mp="3buo7odoync6v">
                    <span className="block font-bold text-navy-900" data-id="element-444" data-mp="3br0ddcboylr3">
                      Office
                    </span>
                    <span className="text-gray-600" data-id="element-445" data-mp="31unjoeg5c7wc">
                      357 7th Ave, 2nd Floor
                      <br data-id="element-446" data-mp="3pkrogp52mdox" />
                      New York, NY 10001, United States
                    </span>
                  </div>
                </li>
                <li className="flex items-start space-x-4" data-id="element-447" data-mp="3uj2zv4b0kw99">
                  <Phone className="h-6 w-6 text-gold-500 mt-1" data-id="element-448" data-mp="3gspmunj9mrd2" />
                  <div data-id="element-449" data-mp="3gqd8slgmp15a">
                    <span className="block font-bold text-navy-900" data-id="element-450" data-mp="3kt9lxwneg51u">Phone</span>
                    <a href="tel:+16788073391" className="text-gray-600 hover:text-gold-600 transition-colors" data-id="element-451" data-mp="cdznqzmmrjzc">+1 (678) 807-3391</a>
                  </div>
                </li>
                <li className="flex items-start space-x-4" data-id="element-452" data-mp="h5zlqmj542ta">
                  <Mail className="h-6 w-6 text-gold-500 mt-1" data-id="element-453" data-mp="21u1xnix1aq3n" />
                  <div data-id="element-454" data-mp="1ww0ekxzlyqs6">
                    <span className="block font-bold text-navy-900" data-id="element-455" data-mp="1wwscwgklb2m5">Email</span>
                    <a href="mailto:contact@talentbridge.blog" className="text-gray-600 hover:text-gold-600 transition-colors" data-id="element-456" data-mp="2bkn6s0ac3d0t">
                      contact@talentbridge.blog
                    </a>
                  </div>
                </li>
                <li className="flex items-start space-x-4" data-id="element-457" data-mp="1ix0rvvvnolyn">
                  <Clock className="h-6 w-6 text-gold-500 mt-1" data-id="element-458" data-mp="1dxeg7qvh7dry" />
                  <div data-id="element-459" data-mp="1dz92b8ihhbxm">
                    <span className="block font-bold text-navy-900" data-id="element-460" data-mp="1su5ge2cz4tim">Hours</span>
                    <span className="text-gray-600" data-id="element-461" data-mp="1ss2gmqm0rm0p">
                      Mon-Fri: 9am - 6pm EST
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            <div className="mt-12 p-6 bg-white rounded-lg shadow-sm" data-id="element-462" data-mp="34beusah8wvd2">
              <h3 className="font-bold text-navy-900 mb-2" data-id="element-463" data-mp="2za7pqj6hmaa3">
                Verify before you share
              </h3>
              <p className="text-gray-600 mb-4 text-sm" data-id="element-464" data-mp="18vqbkjl5b5b5">
                TalentBridge never requests payment, gift cards, or banking credentials in connection with a job opportunity.
              </p>
              <Button variant="outline" fullWidth href="/recruitment-safety" data-id="element-465" data-mp="1hwer5iq6tdq5">
                Verify recruiter outreach
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}